export const FULL_NAME_MIN_LENGTH = 2;
export const FULL_NAME_MAX_LENGTH = 40;

export const PHONE_LOCAL_MAX_LENGTH = 10;
export const PHONE_LOCAL_PATTERN = /^\d{10}$/;
